export const Icona = ({ tipologia }) => (
  <svg className="ld-icon-colors" aria-hidden="true" viewBox="0 0 50 50">
    <use href={window.location.origin + "/sprite.svg#" + tipologia}></use>
  </svg>
);
